/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Machine-readable error code returned in the body of a coded error response. Clients branch on this value, never on the bare HTTP status.
 */
export enum UserSettingErrorCode {
    STALE_VIEW_STATE_VERSION = 'stale_view_state_version',
}
